import { render, staticRenderFns } from "./PermissionMatrixTab.vue?vue&type=template&id=51fdd007&scoped=true"
import script from "./PermissionMatrixTab.vue?vue&type=script&lang=js"
export * from "./PermissionMatrixTab.vue?vue&type=script&lang=js"
import style0 from "./PermissionMatrixTab.vue?vue&type=style&index=0&id=51fdd007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fdd007",
  null
  
)

export default component.exports